import { BottomSheetIllustrationContent, Text } from "@clipboard-health/ui-components";
import { isDefined } from "@clipboard-health/util-ts";
import { Stack } from "@mui/material";
import { Button } from "@src/appV2/redesign/components/Button";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";

export interface ActionNotFoundContentProps {
  action: "clock-in" | "clock-out";
  onTryAgain: (() => void) | undefined;
  onSkipAction: () => void;
  onClose?: () => void;
}

export function ActionNotFoundContent(props: ActionNotFoundContentProps) {
  const { action, onTryAgain, onSkipAction, onClose } = props;
  const actionText = action === "clock-in" ? "Clock in" : "Clock out";

  return (
    <>
      <BottomSheetIllustrationContent
        hasFooter
        illustrationType="error"
        title={`${actionText} not found`}
        description={
          <Stack gap={5}>
            <Text
              semibold
              variant="body1"
              sx={(theme) => ({ color: theme.palette.text.secondary })}
            >
              If you correctly used the workplace time clock, please press try again. It may take a
              few more minutes to sync your {actionText.toLowerCase()}.
            </Text>
          </Stack>
        }
      />
      <DialogFooter
        orientation="vertical"
        closeButtonAriaLabel="Go back"
        closeButtonIconType="arrow-left"
        onClose={onClose}
      >
        {isDefined(onTryAgain) && (
          <Button
            fullWidth
            size="large"
            onClick={() => {
              onTryAgain();
            }}
          >
            Try again
          </Button>
        )}
        <Button
          fullWidth
          variant="destructive"
          size="large"
          onClick={() => {
            onSkipAction();
          }}
        >
          Skip {actionText.toLowerCase()}
        </Button>
      </DialogFooter>
    </>
  );
}
